import { Policy } from '../../apiTypes';
import { GroupType } from './type';

export const name = 'currentGroup';

export const types = {
    SET_CURRENT_GROUP: `${name}/SET_CURRENT_GROUP`,
    SET_CURRENT_GROUP_NAME: `${name}/SET_CURRENT_GROUP_NAME`,
    SET_CURRENT_GROUP_POLICY: `${name}/SET_CURRENT_GROUP_POLICY`,
    CLEAR_ALL: `${name}/CLEAR_ALL`,
    CLEAR_USERS: `${name}/CLEAR_USERS`,
};

export interface CurrentGroupState {
    baseGroup: GroupType;
}

// InitialState
const initialState: CurrentGroupState = {
    baseGroup: null,
};

const reducer = (state = initialState, action: any = {}): any => {
    switch (action.type) {
        case types.SET_CURRENT_GROUP:
            return {
                ...state,
                baseGroup: action.payload.baseGroup,
            };
        case types.SET_CURRENT_GROUP_NAME:
            return {
                ...state,
                baseGroup: { ...state.baseGroup, name: action.payload.groupName },
            };
        case types.SET_CURRENT_GROUP_POLICY:
            return {
                ...state,
                baseGroup: { ...state.baseGroup, policy: action.payload.policy },
            };
        case types.CLEAR_ALL:
            return initialState;
        case types.CLEAR_USERS:
            return {
                ...state,
                baseGroup: {
                    ...state.baseGroup,
                    users: [],
                },
            };
        default:
            return state;
    }
};
export default reducer;

// ActionCreators
export const actions = {
    setCurrentGroup: (baseGroup: GroupType): any => ({ type: types.SET_CURRENT_GROUP, payload: { baseGroup } }),
    setCurrentGroupName: (groupName: string): any => ({ type: types.SET_CURRENT_GROUP_NAME, payload: { groupName } }),
    setCurrentGroupPolicy: (policy: Policy): any => ({ type: types.SET_CURRENT_GROUP_POLICY, payload: { policy } }),
    resetAll: (): any => ({ type: types.CLEAR_ALL }),
    resetUsers: (): any => ({ type: types.CLEAR_USERS }),
};

const localState = (state: any): CurrentGroupState => state[name] || initialState;
export const selectors = {
    currentGroup: (state): GroupType => localState(state).baseGroup,
    currentGroupPolicy: (state): Policy => localState(state).baseGroup.policy,
};
